/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileNoteResponseScope = typeof ProfileNoteResponseScope[keyof typeof ProfileNoteResponseScope];


export const ProfileNoteResponseScope = {
  project: 'project',
  job: 'job',
} as const;
